<div class="grid grid-nogutter">
    <div class="p-0 col-12 mb-5">
        <h3 class="m-0 h4 mb-2">{{'Timekeeping Summary Report' | sentenceCase}}</h3>
    </div>
    <div class="mb-3 xl:col-3 lg:col-3 col-12 lg:pr-3 xl:pr-3 pr-0">
        <p-multiSelect [options]="projects" [(ngModel)]="selectedProjects" optionLabel="codeName" placeholder="Project" (onChange)="onProjectSelectionChange($event)" [ngClass]="{'ng-dirty ng-invalid': showProjectSelectionError}" [resetFilterOnHide]="true" />
        @if(showProjectSelectionError){
            <span class="p-error pl-1 text-xs">This is required</span>
        }
    </div>
    <div class="mb-3 xl:col-3 lg:col-3 col-12 lg:pr-3 xl:pr-3 pr-0">
        <p-multiSelect [options]="roles" [(ngModel)]="selectedRoles" optionLabel="roleType" placeholder="Role" (onChange)="onRolesSelectionChange($event)" [resetFilterOnHide]="true"/>
    </div>
    <div class="mb-3 xl:col-3 lg:col-3 col-12 lg:pr-3 xl:pr-3 pr-0">
        <p-multiSelect [options]="reviewers" [(ngModel)]="selectedReviewers" optionLabel="fullName" placeholder="Candidate" [resetFilterOnHide]="true"/>
    </div>
    
    <!-- Date Selection Toggle -->
    

    <!-- Preset Week Option (Default) -->
    @if(!useCustomDateRange){
        <div class="mb-3 xl:col-3 lg:col-6 col-12 lg:pr-3 xl:pr-3 pr-0">
            <div class="date-slider flex align-items-center justify-content-between">
                <p-button type="button" pRipple [text]="true" [rounded]="true" [plain]="true" icon="pi pi-chevron-left"
                    class="row-toggler" (click)="slider(false)" />
                <span>
                    {{getFormattedDateRange()}}
                </span>
                <p-button type="button" pRipple [text]="true" [rounded]="true" [plain]="true" icon="pi pi-chevron-right"
                    class="row-toggler" (click)="slider(true)" />
            </div>
        </div>
    }

    <!-- Custom Date Range Option -->
    @if(useCustomDateRange){
        <div class="mb-3 xl:col-3 lg:col-3 col-12 lg:pr-3 xl:pr-3 pr-0">
            <p-calendar [(ngModel)]="startDate" [showIcon]="true" placeholder="Start Date" dateFormat="mm/dd/yy" (onSelect)="onDateRangeChange()"/>
        </div>
        <div class="mb-3 xl:col-3 lg:col-3 col-12 lg:pr-3 xl:pr-3 pr-0">
            <p-calendar [(ngModel)]="endDate" [showIcon]="true" placeholder="End Date" dateFormat="mm/dd/yy" (onSelect)="onDateRangeChange()"/>
        </div>
    }

    <div class="mb-3 col-3 flex align-items-center gap-2">
        <p-inputSwitch 
            [(ngModel)]="useCustomDateRange" 
            inputId="date-toggle"
            (onChange)="onDateToggleChange($event)" />
        <label for="date-toggle">{{'Use Custom Date Range' | sentenceCase}}</label>
    </div>
    
    <div class="mb-3 xl:col-3 lg:col-3 col-12 lg:pr-3 xl:pr-3 pr-0">
        <p-dropdown [options]="timezones" [(ngModel)]="selectedTimezone" optionLabel="val" [placeholder]="isDefaultTimeZone ? 'Default timezone' : 'Timezone'" [disabled]="isDefaultTimeZone"  />
    </div>
    <div class="mb-3 xl:col-3 lg:col-4 col-12 lg:pr-3 xl:pr-3 pr-0 flex align-items-center gap-2">
        <p-checkbox 
            [(ngModel)]="isDefaultTimeZone" 
            [binary]="true" 
            inputId="default-tz"
            (onChange)="onChangeDefaultTimezoneCheck($event)" />
        <label for="default-tz">{{'Use Default Timezone' | sentenceCase}}</label>
    </div>
    
    <div class="mb-3 xl:col-3 lg:col-3 col-12 lg:pr-3 xl:pr-3 pr-0">
        <p-button label="search" [rounded]="true" size="large" (click)="generateReport()" />
    </div>
    @if(timekeepingReports.length){
        <div class="flex gap-3 col-12 mb-5 justify-content-end" >
            <p-button label="export pdf" [rounded]="true" size="large" (click)="pdf.toggle($event)"/>
            <p-button label="export csv" [rounded]="true" size="large" (click)="csv.toggle($event)"/>
        </div>
        <div class="flex col-12 gap-4 align-items-center" style="justify-content: space-around;">
            <div class="flex flex-column align-items-center">
                <h5 class="m-0 mb-3">{{'Total Week Hours' | sentenceCase}}</h5>
                <p>{{summary.totalProjectHours}}</p>
            </div>
        </div>
    }
    <div class="p-0 col-12 mt-4">
        <p-table styleClass="p-datatable-sm p-datatable-sm--normal" [value]="timekeepingReports" [paginator]="true" [rows]="2" [tableStyle]="{ 'min-width': '70rem' }"
            [showCurrentPageReport]="true" currentPageReportTemplate="Showing {first} - {last} of {totalRecords}"
            autoLayout="true" [rows]="noOfRows">
            <ng-template pTemplate="header">
                <tr>
                    <th>
                        Date
                    </th>
                    <th>
                        Reviewer
                    </th>
                    <th>
                        Project
                    </th>
                    <th>
                        Role
                    </th>
                    <th>
                        {{'Hours Worked' | sentenceCase}}
                    </th>
                    <th>
                        Rate
                    </th>
                    <th>
                        Total
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-timekeepingReport>
                <tr>
                    <td>{{ timekeepingReport.Date }}</td>
                    <td>{{ timekeepingReport.Reviewer }}</td>
                    <td>{{ timekeepingReport.Project }}</td>
                    <td>{{ timekeepingReport.Role }}</td>
                    <td>{{ timekeepingReport['Hours worked'] || '-' }}</td>
                    <td>{{ timekeepingReport.Rate || '-' }}</td>
                    <td>{{ timekeepingReport.Total || '-' }}</td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>

<p-overlayPanel #pdf>
    <div class="flex flex-column gap-3">
        @for(option of reportOptions; track option) {
            <p-button [label]="option.label" [rounded]="true" size="small" (click)="exportPDF(option.key)" [text]="true"/>
        }
    </div>
</p-overlayPanel>

<p-overlayPanel #csv>
    <div class="flex flex-column gap-3">
        @for(option of reportOptions; track option) {
            <p-button [label]="option.label" [rounded]="true" size="small" (click)="exportCSV(option.key)" [text]="true"/>
        }
    </div>
</p-overlayPanel>